/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorReviewsConversationIssueNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.conversation.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorReviewsConversationIssueNewRoute);
